module.exports = {
  // 请输入表名按回车查询
  pleaseEnterTableName: '请输入表名按回车查询',
  // 请上传文件
  pleaseUploadFile: '请上传文件',
  // 请上传图片
  pleaseUploadAPicture: '请上传图片',
  // 请输入部门名称按回车进行搜索
  searchDept: '请输入部门名称按回车进行搜索',
  // 请上传
  pleaseUpload: '请上传',
  // 普通同步
  normalSync: '普通同步(保留表数据)',
  // 强制同步
  forceSync: '强制同步(删除表,重新生成)',
  // 请确认
  pleaseConfirm: '请确认？',
  // 移除只会删除表单配置、删除会删除对应的数据库表
  confirmRemove: '移除只会删除表单配置、删除会删除对应的数据库表',
  // 请选中该表对应的主表生成代码
  pleaseSelectMainTable: '请选中该表对应的主表生成代码',
  // 请先同步数据库
  pleaseSynchronizeTheDatabaseFirst: '请先同步数据库',
  // 该浏览器不支持自动复制
  thisBrowserDoesNotSupportAutomaticCopying: '该浏览器不支持自动复制',
  // 复制成功
  copySuccessfully: '复制成功',
  // 请选择当前页数据
  pleaseSelectCurrentPageData: '请选择当前页数据',
  // 确认要移除此记录
  confirmToRemoveThisRecord: "确认要移除此记录",
  // 菜单链接
  menuLink: '菜单链接',
  // 已同步
  synced: '已同步',
  // 未同步
  notSynced: '未同步',
  // 确定生成视图吗
  areYouSureGenerateTheView: '确定生成视图吗？',
  areYouSureDeleteItem: '确定要删除这 {num} 项吗',//确定要删除此部门以及子节点数据吗
  // 请输入开始
  pleaseEnterStart: '请输入开始',
  // 请输入结束
  pleaseEnterEnd: '请输入结束',
  startUpload: '开始上传', // 开始上传
  uploading: '上传中...', // 上传中
  queDingFaBuMa: '确定发布吗',
  queDingCheXiaoMa: '确定撤销吗',
  zuihouyiye: '这是最后一页，不能再关闭了啦',//这是最后一页，不能再关闭了啦
  shouyebunengguanbi: '首页不能关闭',//首页不能关闭
  loginTitle: '账号密码登陆', // 账号密码登陆
  dragVerify: '拖动滑块验证', // 拖动滑块验证
  dragSuccess: '验证通过', // 验证通过
  automaticLogin: '自动登陆', // 自动登陆
  pleaseInput: '请输入', // 请输入
  pleaseSelect: '请选择', // 请选择
  confirmDeletion: '确认删除', // 确认删除
  deleteTheSelectedData: '是否删除选中数据?', // 是否删除选中数据
  selected: '已选择', // 已选择
  term: ' 项', //  项
  up: '收起', // 收起
  down: '展开', // 展开
  total: '共 ', // 共
  article: ' 条', // 条
  pleaseSet: '请设置', // 请设置
  isSubmit: '确认提交吗?', // 确认提交吗?
  isWriteOff: '确定冲销吗?', // 确定冲销吗?
  isDelete: '确定删除吗?', // 确定删除吗?
  isSynchronize: '确定同步吗?', // 确定同步吗?
  isCancel: '确定取消吗?', // 确定取消吗?
  isEnable: '确定启用吗?', // 确定启用吗?
  isDisable: '确定禁用吗?', // 确定禁用吗?
  mustBeGreaterThan0: '必须大于0', // 必须大于0
  mustBeGreaterThanOrEqualToZeroInteger: '必须为大于等于零整数', // 必须为大于等于零整数
  mustBeAPositiveInteger: '必须为正整数', // 必须为正整数
  mustBeAnInteger: '必须为整数', // 必须为整数
  filledInUpTo10Characters: '最多填写10个字符', // 最多填写10个字符
  cannotBeEmpty: '不能为空', // 不能为空
  mustBeLessThanOneDecimalPlaces: '必须少于一位小数', // 必须少于一位小数
  mustBeLessThanTwoDecimalPlaces: '必须少于两位小数', // 必须少于两位小数
  mustBeLessThanThreeDecimalPlaces: '入库数量必须少于三位小数', // 必须少于三位小数
  mustBeAPositiveFntegerFrom1To12: '必须为1-12正整数', // 必须为1-12正整数
  pleaseFillInTheInformationCompletely: '请将信息填写完整！', // 请将信息填写完整！
  successfulOperation: '操作成功', // 操作成功
  noData: '暂无数据', // 暂无数据
  fileUploadSuccessful: '文件上传成功', // 文件上传成功
  fileUploadFailed: '文件上传失败', // 文件上传失败
  fileDownloadFailed: '文件下载失败', // 文件上传失败
  none: '无', // 无
  addAtLeastOneItemizedQuantity: '至少添加一条明细的数量！', // 至少添加一条明细的数量！
  confirmSubmission: '确认提交', // 确认提交
  whetherToSubmitTheSelectedData: '是否提交选中数据', // 是否提交选中数据
  tips: '提示', // 提示
  YouDoNotBelongToTheDepartmentPleaseConfirmTheAccountInformation: '您尚未归属部门,请确认账号信息', // 您尚未归属部门,请确认账号信息
  currentOrganizationalStructureWillBeDocumented: '发布版本的同时会将当前组织架构进行记录', // 发布版本的同时会将当前组织架构进行记录
  importantOperations: '重要操作', // 重要操作
  pleaseSelectDepartmentFirst: '请先选择一个部门', // 请先选择一个部门
  areYouSureYouWantToLogOff: '真的要注销登录吗?', // 真的要注销登录吗?
  error: '错误', // 错误
  refreshCacheCompleted: '刷新缓存完成！', // 刷新缓存完成！
  failedToRefreshCache: '刷新缓存失败！', // 刷新缓存失败！
  sureToAbandonEditing: '确定放弃编辑？', // 确定放弃编辑？
  restoreUser: '恢复用户', // 恢复用户
  areYouSureRestore: '您确定要恢复', // 您确定要恢复
  users: '用户', // 用户
  deleteCompletely: '彻底删除',// 彻底删除
  areYouSureDelete: '您确定要彻底删除', // 您确定要彻底删除
  notePleaseBeCarefulItCannotBeRecoveredAfterDeletion: '注意：彻底删除后将无法恢复，请谨慎操作！', // 注意：彻底删除后将无法恢复，请谨慎操作！
  restore: '还原', // 还原
  delete: '删除', // 删除
  successfully: '成功', // 成功
  yourPhoneNumberIncorrect: '您的手机号码格式不正确', // 您的手机号码格式不正确
  currentSelection: '当前选择', // 当前选择
  orgCodeAlreadyExists: '机构编码已存在', // 机构编码已存在
  pleaseSelectARecord: '请选择一条记录',// 请选择一条记录
  pleaseChooseToModify: '请点击选择要修改部门', // 请点击选择要修改部门
  failureOperation: '操作失败', // 操作成功
  areYouSureDeleteDepartmentAndSubData: '确定要删除此部门以及子节点数据吗',//确定要删除此部门以及子节点数据吗
  pleaseSelectParentDepartment: '请先点击选中上级部门', //请先点击选中上级部门
  dataAndSubData: '条数据, 以及子节点数据吗?', // n条数据，及子数据
  confirmTheApproval: '确认审核通过',//确认审核通过
  determineThePlanToReject: '确定计划驳回',//确定计划驳回
  determinedToVoid: '确定作废',//确定作废
  details: '详情', // 详情
  mustBeGreaterThanOrEqualTo: '必须大于等于0',//必须大于等于0
  mustBeLessThanFourDecimalPlaces: '必须少于四位小数',//必须少于四位小数
  mustBeLessThanSixDecimalPlaces: '必须少于六位小数',//必须少于六位小数
  mustBeOrPositiveInteger: '必须是或者正整数',//必须是或者正整数
  rejected: '确定驳回',//确定驳回
  contractBreakdownSheetFailedTo: '合同明细表单校验未通过',//合同明细表单校验未通过
  confrimSynchronization: '确定同步?',//确定同步
  makeSureTheReviewIsApproved: '确定审核通过',//确定审核通过
  confirmRejection: '确定计划驳回',//确定计划驳回
  confirmToVoid: '确定作废',//确定作废
  okToUpdateTheStatement: '确定更新结算单',//确定更新结算单
  okToWithdraw: '确定撤回吗',//确定撤回吗
  theHighestPriceCannotBeLessThanTheLowestPrice: '最高价不能小于最低价',//最高价不能小于最低价
  lowestPriceCannotBeGreaterThanTheHighestPrice: '最低价不能大于最高价',//最低价不能大于最高价
  mustBe0OrAPositiveInteger: '必须为0或正整数',//必须为0或正整数
  theDataIsNotFilledInCompletelyPleaseCheck: '数据没有填完整,请检查',//数据没有填完整,请检查
  theBatchDoesNotHaveTheDeliveryInformation: '该批次没有出栏信息',//该批次没有出栏信息
  noConsumptionInformationForThisBatch: '该批次没有耗用信息',//该批次没有耗用信息
  theVerificationOfTheBatchDetailsDidNotPass: '出栏明细校验未通过',//出栏明细校验未通过
  feedingBatchNeedsToBeSelected: '饲养批次需要选择',//饲养批次需要选择
  marginFormCheckFailed: '保证金表单校验未通过',//保证金表单校验未通过
  departmentSwitching: '部门切换',//部门切换
  currentDepartment: '当前部门',//当前部门
  pleaseSelectSettlementBatchNumber: '请选择结算批次编号'//请选择结算批次编号
}